import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { TINY_URLS } from '../../constants/tableTypes'
import { STORE_TINY_URLS } from '../../constants/actionTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const tinyUrlsReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_TINY_URLS:
      return {
        ...state,
        content: action.tableValues.content,
      }
    default:
      return reducers.dataTable.tableFetchReducer(TINY_URLS, state, action)
  }
}

export default combineReducers({
  data: tinyUrlsReducer,
  tableInfo: tableReducer,
})

export { initialState, tinyUrlsReducer }
